import type { PopupVisibility } from "@/api/AppApi/services/company/interfaces/ICompany";

const defaultVisibility: readonly PopupVisibility[] = ["guests", "logged_in"];

export function needsPopupOrderCount(
  visibility: readonly PopupVisibility[] | null | undefined,
  signedIn: boolean,
): boolean {
  const options = visibility ?? defaultVisibility;
  return (
    signedIn &&
    !options.includes("logged_in") &&
    options.includes("logged_in_no_orders")
  );
}

export function matchesPopupVisibility(
  visibility: readonly PopupVisibility[] | null | undefined,
  signedIn: boolean,
  orderCount?: number,
): boolean {
  const options = visibility ?? defaultVisibility;
  if (!signedIn) return options.includes("guests");
  return (
    options.includes("logged_in") ||
    (options.includes("logged_in_no_orders") && orderCount === 0)
  );
}
